<template>
    <table class="table table-striped additions-table">
        <thead>
            <tr>
                <th colspan="4">{{ trans.attendance.variable_wage }}</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th>
                    {{ this.getVariableWageTypeLabel() }}:

                    <div class="float-right">
                        <button
                            class="btn btn-link p-0"
                            @click="unsetCustomVarWage()"
                            v-b-tooltip.hover
                            :title="trans.resetVariableWage"
                            v-if="this.varWageIsModified"
                        >
                            <i
                                class="fas fa-spinner text-danger"
                                v-if="this.varWageUnsetLoading"
                            ></i>
                            <i class="fal fa-fw fa-sync text-danger" v-else></i>
                        </button>
                    </div>
                </th>
                <td class="text-right" style="width: 40%;" colspan="2">
                    <div class="input-group">
                        <input
                            type="number"
                            step="0.01"
                            class="form-control"
                            v-model="mutableVarWageAmount"
                            :disabled="varWageLoading"
                            :class="{ 'loading disabled': varWageLoading }"
                            autocomplete="off"
                            @blur="fixEmptyAmount($event.target.value)"
                        />
                        <div class="input-group-append">
                            <span class="input-group-text">
                                {{ restaurantCurrency }}
                            </span>
                        </div>
                    </div>
                </td>
                <td style="width: 10%;">
                    <button
                        type="button"
                        class="btn btn-success btn-square-loading-save"
                        :class="{ 'loading disabled': varWageLoading }"
                        @click="saveVarWage"
                    >
                        <i class="fal fa-save"></i
                        ><i class="loadingSpinner"></i>
                    </button>
                </td>
            </tr>

            <tr>
                <td style="width: 50%">
                    <b>{{ trans.attendance.variable_wage_together }}:</b>
                </td>
                <td class="pl-3" v-if="this.isHourlyWage()">
                    &times; <b>{{ formatHours(workedHoursTotal) }}</b>
                </td>
                <td class="text-right">
                    <b
                        ><span
                            v-html="this.getMutableVarWageAmountTotal()"
                        ></span
                    ></b>
                </td>
                <td class="text-center" style="white-space: nowrap;"></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import {formatHours,formatMoney} from "../../utils";
export default {
        name: 'variable-wages',
        data: function() {
            return {
                mutableVarWageAmount: this.varWageAmount,
                varWageLoading: false,
                varWageUnsetLoading: false,
            }
        },

        props: {
            'varWageAmount': {
                type: Number
            },
            'varWageIsModified': {
                type: Boolean
            },
            'trans': {
                type: Object
            },
            'restaurantCurrency': {
                type: String
            },
            'varWageUrlSave': {
                type: String
            },
            'varWageUrlUnset': {
                type: String
            },
            'contractSettings': {
                type: Object
            },
            'workedHoursTotal': {
                type: Number
            }
        },

        created() {
        },

        methods: {
            formatHours(x) {
                return formatHours(x);
            },
            formatMoney(x) {
                return formatMoney(x, this.restaurantCurrency);
            },
            fixEmptyAmount(val) {
                if (val === "" || val == null) {
                    this.mutableVarWageAmount = 0;
                }
            },
            getMutableVarWageAmountTotal() {
                return formatMoney(this.isHourlyWage() ? this.workedHoursTotal * this.varWageAmount : this.varWageAmount, this.restaurantCurrency);
            },
            saveVarWage()  {
                this.varWageLoading = true;
                const data = {
                    amount: this.mutableVarWageAmount
                };

                axios.post(this.varWageUrlSave, data).then(response => {
                    this.varWageLoading = false;
                    this.refreshAttendance(false);
                    this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                }).catch(error => {
                    this.varWageLoading = false;
                    this.refreshAttendance(false);
                    this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                })
            },
            unsetCustomVarWage() {
                this.varWageUnsetLoading = true;

                axios.post(this.varWageUrlUnset, null).then(response => {
                    this.varWageUnsetLoading = false;
                    this.refreshAttendance();
                    this.mutableVarWageAmount = response.data.profileVariableWage;
                    this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                }).catch(error => {
                    this.varWageUnsetLoading = false;
                    this.refreshAttendance();
                    this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                });
            },
            refreshAttendance(withLoading = true) {
                this.$parent.$emit('refreshattendance', withLoading);
            },
            getVariableWageTypeLabel()
            {
                return (this.isHourlyWage() ? this.trans.variableWageLabels.hourly : this.trans.variableWageLabels.monthly);
            },
            isHourlyWage()
            {
                return (this.contractSettings.salaryVariableWageType == 1);
            }
        }
    }
</script>

<style lang="scss" scoped>
.btn-square-loading-save,
.btn.loading.btn-square-loading-save {
    width: 38px;
    height: 35px;
    padding-right: 0.75rem !important;
    text-align: center;

    .loadingSpinner {
        margin-left: -10px;
        left: auto;
        right: auto;
    }
}
.form-control {
    padding-right: 12px !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/VariableWages.vue